/* unplugin-vue-components disabled */import script from "./ChatApps.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatApps.vue?vue&type=script&setup=true&lang=ts"

import "./ChatApps.vue?vue&type=style&index=0&id=9e759d86&lang=stylus"

const __exports__ = script;

export default __exports__